"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _useStreamSLI = require("./useStreamSLI");
Object.keys(_useStreamSLI).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _useStreamSLI[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _useStreamSLI[key];
    }
  });
});